import { Injectable, inject } from '@angular/core';
import { AuthService } from '@core/api/auth/auth.service';
import { ModalService } from '@shared/components/modal/modal.service';
import { PasswordChangeReminderModalComponent } from '@shared/components/password-change-reminder-modal/password-change-reminder-modal.component';

@Injectable({
    providedIn: 'root',
})
export class PasswordChangeCheckService {
    private authService = inject(AuthService);
    private modalService = inject(ModalService);
    private hasShownModal = false;

    checkPasswordExpiry(): void {
        const user = this.authService.user();

        if (!user || !user.password_change_waived_until || this.hasShownModal) {
            return;
        }

        const expiryDate = new Date(user.password_change_waived_until);
        const now = new Date();

        // Check if password change is required (expiry date has passed)
        if (expiryDate <= now) {
            this.hasShownModal = true;
            this.showPasswordChangeModal();
        }
    }

    private showPasswordChangeModal(): void {
        this.modalService.open({
            title: 'Security Notice',
            contentComponent: PasswordChangeReminderModalComponent,
            size: 'md',
            position: 'center',
            backdropDismiss: false,
            keyboardClose: false,
            showCloseButton: false,
        });
    }

    reset(): void {
        this.hasShownModal = false;
    }
}
